import Api from './Api.js';

var api = new Api();

export default api;
